import { PagingFilterTypeEnum } from 'Common/Constants/Enumeration/PagingFilterTypeEnum';

export const SORT_DIRECTION = {
  ASC: 'asc',
  DESC: 'desc',
};

/**
 * Converts react table state's sorted into SortColumn
 * SortColumn is the class used for sorting
 * @param {Array} sorted
 */
export const convertGridSortToSortColumn = (sorted = []) => {
  return sorted.map((s) => ({
    SortName: s.id,
    SortDirection: s.desc ? SORT_DIRECTION.DESC : SORT_DIRECTION.ASC,
  }));
};

/**
 * Converts react table state's filtered into Filter
 * Filter is the class used for filtering
 * @param {Array} filtered
 * @param {PagingFilterTypeEnum} filterType
 */
export const convertGridFilterToFilter = (
  filtered = [],
  filterType = PagingFilterTypeEnum.Contains
) => {
  return filtered.map((f) => ({
    FilterName: f.id,
    FilterValue: f.value,
    FilterType: filterType,
  }));
};



// WEBPACK FOOTER //
// ./src/state/paging/helpers.js